import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneIcon from '@mui/icons-material/Phone';
import Email from '@mui/icons-material/Email';

const policyData = [
  {
    label: 'Privacy Policy',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Privacy+Policy.pdf',
  },
  {
    label: 'Refund Policy',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Refund+Policy.pdf',
  },
  {
    label: 'Cancellation Policy',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Cancelation+Policy.pdf',
  },
  {
    label: 'Terms and Conditions',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Terms+of+Use+of+Humbee.pdf',
  },
];

const theme = createTheme({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          marginBottom: '1rem',
          boxShadow: 'none', // Remove default box shadow
          '&:before': {
            // Remove default border
            display: 'none',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        expandIcon: {
          // Style expand icon
          color: '#000',
        },
        content: {
          // Style summary content
          margin: '0',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          // Style question text
          fontWeight: 'bold',
        },
      },
    },
  },
});
const ContactUsAndPolicies = () => {
  return (
    <ThemeProvider theme={theme}>
        <Container
          maxWidth='true'
          sx={{
            pl: '2rem',
            pt: '2rem',
            height: window.innerHeight,
            overflowY: 'auto',
            backgroundColor: 'rgba(245,245,245,.6)',
          }}
        >
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={'contact-us'}
              id={`contact-us`}
              sx={{ backgroundColor: '#f5f5f5' }}
            >
              <Typography variant='h6'>Contact Us</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ width: '60%', ml: '1rem' }}>
                <Stack
                  spacing={2}
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  alignContent={'center'}
                >
                  <Stack
                    direction={'row'}
                    spacing={2}
                  >
                    <Typography
                      variant='body1'
                      fontWeight={'600'}
                    >
                      Phone Number
                    </Typography>
                    <PhoneIcon />
                  </Stack>
                  <Typography
                    variant='body1'
                    fontWeight={'600'}
                  >
                    18002100123
                  </Typography>
                </Stack>
                <Stack
                  spacing={2}
                  direction={'row'}
                  justifyContent={'space-between'}
                >
                  <Stack
                    direction={'row'}
                    spacing={2}
                  >
                    <Typography
                      variant='body1'
                      fontWeight={'600'}
                    >
                      Email
                    </Typography>
                    <Email />
                  </Stack>
                  <Typography
                    variant='body1'
                    fontWeight={'600'}
                  >
                    humbee.care@20p95.com
                  </Typography>
                </Stack>
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={'contact-us'}
              id={`contact-us`}
              sx={{ backgroundColor: '#f5f5f5' }}
            >
              <Typography variant='h6'>Policies</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack
                spacing={2}
                direction={'column'}
              >
                {policyData.map((policy, index) => (
                  <Button
                    variant='link'
                    component='a'
                    href={policy.url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {policy.label}
                  </Button>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Container>
    </ThemeProvider>
  );
};
export default ContactUsAndPolicies;
